import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { RentType } from '@/lib/constants';
import { homeConfig } from '@/modules/home/homeConfig';

type Props = {
  range: [number, number];
  type: string;
};

export default function DateTimeRangeCalculation({ range, type }: Props) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  const duration = React.useMemo(() => {
    if (!type) return null;
    if (type === RentType.CAR) {
      return (
        dayjs(range[1] * 1000)
          .startOf('days')
          .diff(dayjs(range[0] * 1000).startOf('days'), 'days') + 1
      );
    }
    return Math.round((range[1] - range[0]) / 3600);
  }, [range, type]);

  const time = React.useMemo(() => {
    if (!duration) return null;
    const time = [];
    if (type === RentType.BIKE) {
      const ww = Math.floor(duration / (7 * 24));
      if (ww > 1) time.push(`${ww} ${t('booking:datetime_picker.weeks')}`);
      if (ww === 1) time.push(`${ww} ${t('booking:datetime_picker.week')}`);

      const dd = Math.floor((duration % (7 * 24)) / 24);
      if (dd > 1) time.push(`${dd} ${t('booking:datetime_picker.days')}`);
      if (dd === 1) time.push(`${dd} ${t('booking:datetime_picker.day')}`);

      const hh = duration % 24;

      if (hh > 1) time.push(`${hh} ${t('booking:datetime_picker.hours')}`);
      if (hh === 1) time.push(`${hh} ${t('booking:datetime_picker.hour')}`);
    }

    if (type === RentType.CAR) {
      const ww = Math.floor(duration / 7);
      if (ww > 1) time.push(`${ww} ${t('booking:datetime_picker.weeks')}`);
      if (ww === 1) time.push(`${ww} ${t('booking:datetime_picker.week')}`);
      const dd = Math.floor(duration % 7);
      if (dd > 1) time.push(`${dd} ${t('booking:datetime_picker.days')}`);
      if (dd === 1) time.push(`${dd} ${t('booking:datetime_picker.day')}`);
    }
    return time;
  }, [duration, t]);

  return <>{time && time.join(', ')}</>;
}

/**
 * Prepare for using timeConfig response from BE estimation
 */
// type Props = {
//   range?: [number, number];
//   timeConfig?: EstimateFeeTimeDetail;
// };

// export default function DateTimeRangeCalculation({ range, timeConfig }: Props) {
//   const { t } = useTranslation(homeConfig.i18nNamespaces);

//   if (timeConfig) {
//     const time = [];
//     const ww = timeConfig.weekly?.rent_unit ?? 0;
//     if (ww > 1) time.push(`${ww} ${t('booking:datetime_picker.weeks')}`);
//     if (ww === 1) time.push(`${ww} ${t('booking:datetime_picker.week')}`);

//     const dd = timeConfig.daily?.rent_unit ?? 0;
//     if (dd > 1) time.push(`${dd} ${t('booking:datetime_picker.days')}`);
//     if (dd === 1) time.push(`${dd} ${t('booking:datetime_picker.day')}`);

//     const hh = timeConfig.hourly?.rent_unit ?? 0;
//     if (hh > 1) time.push(`${hh} ${t('booking:datetime_picker.hours')}`);
//     if (hh === 1) time.push(`${hh} ${t('booking:datetime_picker.hour')}`);

//     return <>{time.join(', ')}</>;
//   }

//   if (range) {
//     const startDate = dayjs.unix(range[0]);
//     const endDate = dayjs.unix(range[1]);
//     const duration = endDate.diff(startDate, 'hour');

//     const tm = [];
//     const ww = Math.floor(duration / (7 * 24));
//     if (ww > 1) tm.push(`${ww} ${t('booking:datetime_picker.weeks')}`);
//     if (ww === 1) tm.push(`${ww} ${t('booking:datetime_picker.week')}`);

//     const dd = Math.floor((duration % (7 * 24)) / 24);
//     if (dd > 1) tm.push(`${dd} ${t('booking:datetime_picker.days')}`);
//     if (dd === 1) tm.push(`${dd} ${t('booking:datetime_picker.day')}`);

//     const hh = duration % 24;
//     if (hh > 1) tm.push(`${hh} ${t('booking:datetime_picker.hours')}`);
//     if (hh === 1) tm.push(`${hh} ${t('booking:datetime_picker.hour')}`);

//     return <>{tm.join(', ')}</>;
//   }

//   return <></>;
// }
